export default function() {
  return (Math.random() - 0.5) * 1e-6;
}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-force/src/jiggle.js
// module id = ../../../../d3-force/src/jiggle.js
// module chunks = 4